export class User {
	constructor(userData = {}) {
		const {
			UserId = '',
			CustId = '',
			UserName = '',
			FirstName = '',
			MiddleName = '',
			LastName = '',
			CompanyName = '',
			EmailAddress = '',
			PhoneNumber = '',
			Role = '',
			Region = '',
			Location = '',
			IsUserActivated = '',
			UserCapabilities = '',
			LastActiveDate = '',
			IsAccountOwner = false,
		} = userData;
		Object.assign(this, {
			UserId,
			CustId,
			UserName,
			FirstName,
			MiddleName,
			LastName,
			CompanyName,
			EmailAddress,
			PhoneNumber,
			Role,
			Region,
			Location,
			IsUserActivated,
			UserCapabilities,
			LastActiveDate,
			IsAccountOwner,
		});
	}
}
